import { inlineStyle } from "../../../style/const/chat/inline_style"
import { IStyle } from "../../../style/const/chat/interface"

export const inlineStyleNum = (styleName: string) => {
  const styleObj: IStyle | undefined = inlineStyle.find(
    style => style.name === styleName,
  )
  if (styleObj) {
    return styleObj.id
  }
  return null
}

export const inlineStyleName = (styleNum: number) => {
  const styleObj: IStyle | undefined = inlineStyle.find(
    style => style.id === styleNum,
  )
  if (styleObj) {
    return styleObj.name
  }
  return null
}
